<template>
	<ion-page>
		<ion-header class="ion-no-border">
			<ion-toolbar>
				<ion-title
					>{{ $t('História parametra') }} <br /><b>{{ parameter?.name }}</b></ion-title
				>

				<ion-button @click="handleDismiss" color="medium" fill="clear" slot="end">
					<ion-icon :icon="close"></ion-icon>
				</ion-button>
			</ion-toolbar>
		</ion-header>
		<ion-content class="result">
			<div class="result__chart" :class="{ 'not-found': historyNotFound || parameterNotFound }">
				<template v-if="parameterHistory">
					<MdxChart :range="parameter.reference_interval" :unit="parameter.unit" :chartData="transformData(parameterHistory.result_history)" />
					<div class="result__chart__arrows">
						<button class="result__chart__arrows__btn-left" :class="{ inactive: currentPage >= Math.ceil(parameterHistory.result_history.length / 10) - 1 }" @click="handleNextPage">
							<ion-icon :icon="arrowBackCircleOutline"></ion-icon>
						</button>
						<button class="result__chart__arrows__btn-right" :class="{ inactive: currentPage === 0 }" @click="handlePreviousPage">
							<ion-icon :icon="arrowForwardCircleOutline"></ion-icon>
						</button>
					</div>
				</template>

				<template v-else-if="historyNotFound">
					<p class="text-center">{{ $t('Pre tento parameter nebola nájdená žiadna história') }}</p>
				</template>

				<template v-else-if="parameterNotFound">
					<p class="text-center">{{ $t('Tento parameter nebol nájdeny') }}</p>
				</template>

				<template v-else>
					<div class="skelet w-[100%] h-[300px]"></div>
				</template>
			</div>

			<div class="result__container" :class="{ 'not-found': historyNotFound || parameterNotFound }">
				<!-- TODO Preklik -->
				<!-- <p class="parameter-link">{{ $t('Prečítajte si celý popis parametra na medirex.sk') }}</p> -->

				<h4>{{ $t('Interpretácia pre lekára') }}</h4>
				<div class="result__container__description" v-html="dompurify(parameterHistory?.parameter?.interpretation_for_doctor) || '-'"></div>
			</div>

			<ion-fab vertical="bottom" horizontal="end" slot="fixed">
				<ion-fab-button @click="openExternalParameterInfo">
					<ion-icon :icon="informationCircleOutline"></ion-icon>
				</ion-fab-button>
			</ion-fab>
		</ion-content>
	</ion-page>
</template>

<script>
import { modalController } from '@ionic/vue'
import { close, arrowForwardCircleOutline, arrowBackCircleOutline, informationCircleOutline } from 'ionicons/icons'
import MdxChart from './_components/mdx-parameter-chart.vue'
import { dompurify } from '@/plugins/app/_config/modules/global-properties'

export default {
	components: {
		modalController,
		MdxChart
	},

	props: {
		query: {
			type: String,
			required: true
		},
		parameter: {
			type: Object,
			required: true
		}
	},

	setup() {
		return {
			dompurify,
			close,
			informationCircleOutline,
			arrowForwardCircleOutline,
			arrowBackCircleOutline
		}
	},
	data() {
		return {
			currentPage: 0,
			historyNotFound: false,
			parameterNotFound: false,
			parameterHistory: null
		}
	},

	async created() {
		try {
			// const { result_history } = await this.$axios.get_auth_data(`v1/results/history?${this.query}`)
			const { result_history } = await this.$axios.post_auth_data(`v1/results/history`,{
				...this.query
			})
			this.parameterHistory = result_history[0]
		} catch (error) {
			if (error.data.error == 'results.history.not_found') {
				return (this.historyNotFound = true)
			}
			if (error.data.error == 'results.parameter.not_found') {
				return (this.parameterNotFound = true)
			}
			this.$toast.error(error)
		}
	},

	computed() {
		// TODO
		this.currentPage = Math.floor(this.parameterHistory?.result_history?.length / 10)
	},

	methods: {
		handleDismiss() {
			modalController.dismiss(null, 'cancel')
		},
		handleNextPage() {
			if (this.currentPage < Math.ceil(this.parameterHistory.result_history.length / 10) - 1) {
				this.currentPage += 1
				this.transformData(this.parameterHistory.result_history)
			}
		},
		handlePreviousPage() {
			if (this.currentPage > 0) {
				this.currentPage -= 1
				this.transformData(this.parameterHistory.result_history)
			}
		},

		transformData(data) {
			let startIndex = data.length - 10 * (this.currentPage + 1)
			if (startIndex < 0) {
				startIndex = 0
			}
			const slicedData = data.slice(startIndex, startIndex + 10)

			return {
				labels: slicedData.map(({ sampling_date }) => {
					const d = new Date(sampling_date)
					return `${d.getDate().toString().padStart(2, '0')}.${(d.getMonth() + 1).toString().padStart(2, '0')}.${d.getFullYear()}`
				}),

				datasets: [
					{
						data: slicedData.map(({ value }) => Number(value.value)),
						backgroundColor: slicedData.map(({ value }) => (Number(value.value) < this.parameter.reference_interval.low || Number(value.value) > this.parameter.reference_interval.high ? '#F01010' : '#015AE9'))
					}
				]
			}
		},

		openExternalParameterInfo() {
			window.open(`https://www.medirex.sk/lekar/detail-parametra/external/${this.parameter.parameter_id || this.parameter.id}`, '_blank')
		}
	}
}
</script>
<style lang="sass" scoped>
@import '@/plugins/app/theme/_mixins/responsive.mixin'

ion-header
	ion-toolbar
		--background: none
		--min-height: 130px
		@apply mb-[3px]

		ion-title
			@apply font-normal text-2xl leading-[29px] text-[#213353]
			+sm
				@apply text-xl

		ion-button
			@apply absolute top-0 right-[-7px] translate-y-[-5%]

.result
	--overflow: hidden
	&__chart
		@apply mb-[30px] px-[60px] flex flex-col h-[50%] items-center

		+sm
			@apply h-[30%]

		&.not-found
			@apply h-[20%]

		&__arrows
			@apply flex justify-between relative w-[100%]

			button
				@apply absolute transform -translate-y-[32px] top-0

			&__btn-left
				@apply  left-0
				ion-icon
					@apply text-[var(--ion-color-primary)] text-[24px]
				ion-icon:hover
					color: var(--ion-color-primary-shade)
			&__btn-right
				@apply  right-0
				ion-icon
					@apply text-[var(--ion-color-primary)] text-[24px]
				ion-icon:hover
					color: var(--ion-color-primary-shade)

		+md
			@apply block px-4

	&__container
		@apply bg-[#f4f6f8] px-[60px] pt-[30px] overflow-y-scroll h-full mx-[1px] pb-[30px]
		max-height: calc( 50% - 30px)

		+sm
			max-height: calc( 70% - 30px)

		&.not-found
			max-height: calc( 80% - 30px)

		&::-webkit-scrollbar
			width: 5px

		&::-webkit-scrollbar-track
			background: transparent

		&::-webkit-scrollbar-thumb
			background: var(--ion-color-medium)

		&::-webkit-scrollbar-thumb:hover
			background: var(--ion-color-medium-shade)

		h4
			@apply text-[#213353] font-bold text-xl

		.parameter-link
			@apply text-[--ion-color-primary] hover:text-[--ion-color-primary-shade] cursor-pointer mb-[10px]

		:deep(.result__container__description)
			p
				@apply leading-6 mb-6
			h5
				@apply font-bold text-sm mb-0 mt-0
			ul
				@apply list-disc ml-6 mb-6
				li
					@apply text-sm leading-6 text-[#213353]

		+md
			@apply px-4

.inactive
	ion-icon
		@apply text-[#B3CCE8]
.inactive:hover
	ion-icon
		@apply text-[#B3CCE8]
</style>
